<template>
<div>
    <el-dialog
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    :title="textMap[dialogStatus]"
    :visible.sync="dialogFormVisible"
    width="60%"
    @close="clearForm()">
        <el-form
        :model="listForm"
        ref="listForm"
        :rules="validateRule"
        label-width="100px"
        >
            <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="列名称" prop="infoItemId">
                <el-input :disabled="this.dialogStatus=='update'" v-model="listForm.infoItemId" />
                </el-form-item>
            </el-col>


            <el-col :span="12">
                <el-form-item label="所属信息集" prop="infoSetId">
                <el-input disabled="true" v-model="listForm.infoSetId" />
                </el-form-item>
            </el-col>



            <el-col :span="12">
                <el-form-item label="中文名称" prop="infoItemName">
                <el-input v-model="listForm.infoItemName" />
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="英文名称"  prop="infoItemEnName">
                <el-input v-model="listForm.infoItemEnName" />
                </el-form-item>
            </el-col>



            <el-col :span="12">
                <el-form-item label="数据类型" prop="infoItemType" >
                    <el-select v-model="listForm.infoItemType" placeholder="请选择">
                        <el-option v-for="item in this.valueType"
                        :key="item.codeItemId"
                        :value="item.codeItemId"
                        :label="item.codeItemName"
                        >
                        </el-option>
                    </el-select>
                <!-- <el-input v-model="listForm.infoItemType" /> -->
                </el-form-item>
            </el-col>



            <el-col :span="12">
                <el-form-item label="是否必填" prop="isRequired">
                <el-select v-model="listForm.isRequired" >
                    <el-option key="1" value="1" label="是"></el-option>
                    <el-option key="0" value="0" label="否"></el-option>
                </el-select>

                <!--<el-input v-model="listForm.isRequired" />-->
                </el-form-item>
            </el-col>



            <el-col :span="12">
                <el-form-item label="默认值" prop="defaultValue">
                <el-input v-model="listForm.defaultValue" />
                </el-form-item>
            </el-col>


            <el-col :span="12">
                <el-form-item label="输入类型" prop="inputType">
                <el-select v-model="listForm.inputType"  placeholder="请选择">
                    <el-option v-for="item in iType"
                     :key="item.codeItemId"
                     :value="item.codeItemId"
                     :label="item.codeItemName"
                    >
                    </el-option>
                </el-select>

                <!-- <el-input v-model="listForm.inputType" /> -->
                </el-form-item>
            </el-col>



            <el-col :span="12">
                <el-form-item label="编辑类型" prop="editType">
                <el-input v-model="listForm.editType" />
                </el-form-item>
            </el-col>



            <el-col :span="12">
                <el-form-item label="排序号" prop="infoItemOrder">
                <el-input v-model="listForm.infoItemOrder" />
                </el-form-item>
            </el-col>



            <el-col :span="12">
                <el-form-item label="分组" prop="infoItemGroup">
                <el-input v-model="listForm.infoItemGroup" />
                </el-form-item>
            </el-col>


            <el-col :span="12">
                <el-form-item label="长度" prop="infoItemLength">
                <el-input v-model="listForm.infoItemLength" />
                </el-form-item>
            </el-col>



            <el-col :span="12">
                <el-form-item label="描述" prop="remark">
                <el-input v-model="listForm.remark" />
                </el-form-item>
            </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <el-button type="primary" :disabled="btnUnable" @click="handlerListForm()">保 存</el-button>
            <el-button @click="cancel()">取 消</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {saveSysInfoItem,editSysInfoItem,checkInfoItemId} from '@/api/sys/info'

export default {
    name: 'SysInfoItemDialog',
    props:{
        dialogStatus:{
            type: String,
            default: ""
        },
        dialogFormVisible: {
            type: Boolean
        },
        listForm:{
            type:Object,
            default: {}
        },
        rowTenantId:{
            type: String,
            default: ''
        },
        rowInfoSetId:{
            type: String,
            default: ''
        },
        eType:{
            type: Array,
            default: []
        },
        iType:{
            type: Array,
            default: []
        },
        valueType:{
            type: Array,
            default:[]
        }
    },

    created() {

    },
    data() {
        let validateInfoItemId = (rule,value,callback) =>{
            let tenantId=this.role.tenantId
            if(this.dialogStatus == 'update ' ){
                callback();
            }
            checkInfoItemId(tenantId,value,this.$route.query.infoSetId).then(res =>{
                this.isExistInfoItemId=res.data
            })
            if(this.isExistInfoItemId){
                console.log('存在相同的infoSetId')
                callback(new Error('存在相同的infoSetId'))
            }else{
                console.log('infoSetId验证通过')
                callback();
            }
        }
        return {
            // 弹框状态
            dialogStatus: 'add',
            dialogFormVisible: false,
            isExistInfoItemId: false,
            listForm:{},
            btnUnable:false,
            //TODO 需要真实用户
            role: {
                name: 'admin',
                tenantId: 'sys'
            },
            textMap: {
                add: "新增信息项",
                update: "编辑信息项"
            },
            validateRule:{
                infoItemId: [
                    { required: true, message: "列名称不能为空！", trigger: "blur"},
                    { required: true, trigger: "blur", validator: validateInfoItemId}
                ],
                infoItemName: [
                    { required: true, message: "信息集中文名不能为空！", trigger: "blur"}
                ],
                infoItemLength: [
                    { required: true, message: "数据长度不能为空！", trigger: "blur"}
                ],
                infoItemType: [
                    { required: true, message: "数据类型不能为空！", trigger: "blur"}
                ],
                infoItemType: [
                    { required: true, message: "数据类型不能为空！", trigger: "blur"}
                ],
                isRequired: [
                    { required: true, message: "必填类型不能为空！", trigger: "blur"}
                ],
            }
        }
    },
    methods: {
        handlerListForm() {
            console.log('当前dialog状态为：'+this.dialogStatus)
            console.log('当前listForm为：'+ JSON.stringify(this.listForm))
            if (this.dialogStatus === "add") {
            this.addForm();
            } else if (this.dialogStatus === "update") {
            this.updateForm();
            }
        },
        addForm(){
            this.$refs.listForm.validate((valid) => {
                console.log('是否通过验证：'+valid)
                this.btnUnable=true
                if(valid){
                    // this.$set(this.listForm, 'infoSetId', this.rowInfoSetId)
                    saveSysInfoItem(this.listForm).then((res)=>{
                        console.log(JSON.stringify(res))
                        if (res.data.code == 0){
                            this.dialogFormVisible = false;
                            this.btnUnable=false
                            this.$emit('data-refresh');
                            this.$message.success(res.data.msg);
                        } else {
                            this.btnUnable=false
                            this.$message.error(res.data.msg);
                        }
                        if(res.status==500){
                            this.btnUnable=false
                        }
                    })
                }
            })
        },
        updateForm() {
            this.btnUnable=true
            this.$refs.listForm.validate((valid) => {
                console.log('是否通过验证：'+valid)
                if (valid){
                    //修改数据不包括状态
                    this.$set(this.listForm, 'infoItemStatus', "")
                    editSysInfoItem(this.listForm).then(res => {
                    if (res.data.code == 0){
                        this.btnUnable=false
                        this.dialogFormVisible = false;
                        this.$emit('data-refresh');
                        this.$message.success(res.data.msg);
                    } else {
                        this.btnUnable=false
                        this.$message.error(res.data.msg);
                    }
                    })
                }else{
                    this.btnUnable=false
                }
            })
        },
        // 关闭后清空dialog
        clearForm(){
        this.$refs.listForm.resetFields()
        this.$refs.listForm.clearValidate()
        this.dialogFormVisible = false
        this.btnUnable=false
        this.$emit('update:dialogFormVisible',false)
        },
        cancel(){
            this.dialogFormVisible = false
            this.$emit('update:dialogFormVisible',false)
        }
    }
}
</script>
